import * as types from '@/store/mutation-types'
import axios from 'axios'
import Vue from 'vue'

const state = {
  status: '',
  profile: JSON.parse(localStorage.getItem('profile')) || {}
}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.nombreCompleto
}

const actions = {
  [types.FETCH_USER]: ({commit, distpach}) => {
    commit(types.FETCH_USER)
    axios.get('alumno/perfil')
      .then(resp => {
        commit(types.FETCH_USER_SUCCESS, resp.data.alumno)
        localStorage.setItem('profile', JSON.stringify(resp.data.alumno))
      })
      .catch(() => {
        commit(types.FETCH_USER_FAILURE)
        distpach(types.AUTH_LOGOUT)
      })
  }
}

const mutations = {
  [types.FETCH_USER]: (state) => {
    state.status = 'loading'
  },
  [types.FETCH_USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [types.FETCH_USER_FAILURE]: (state) => {
    state.status = 'error'
  },
  [types.AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js